import React from 'react'

const Count=() =>{
  return (
    <div>
      <>
      <div id='coun'>

      
      <div className="container">
    
    <div className="row">

	<div className="four col-md-3">
		<div className="counter-box colored">
			<i className="fa fa-thumbs-o-up"></i>
			<span className="counter">50000+</span>
			<p>Insurance Agents</p>
		</div>
	</div>
	<div className="four col-md-3">
		<div className="counter-box">
			<i className="fa fa-group"></i>
			<span className="counter">3000+</span>
			<p>Insurance Offices</p>
		</div>
	</div>
	<div className="four col-md-3">
		<div className="counter-box">
			<i className="fa  fa-shopping-cart"></i>
			<span className="counter">5000+</span>
			<p>Available Plans</p>
		</div>
	</div>
	<div className="four col-md-3">
		<div className="counter-box">
			<i className="fa  fa-user"></i>
			<span className="counter">724743+</span>
			<p>Crore Revenue</p>
		</div>
	</div>
  </div>	
</div>
</div>
      </>
    </div>
  )
}

export default Count
